import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpHeaders, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpUserEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SpinnerService } from '../services/spinner.service';
import { ToastrService } from '../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';

import * as _ from 'lodash';
import * as http_errors from '../../assets/i18n/http_errors';
import { Router } from '@angular/router';

/*
 * Interceptor that handles calls to the back and answers
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {


   constructor(private authService: AuthService,
      private toastService: ToastrService,
      private spinnerService: SpinnerService,
      private translateService: TranslateService) { }
      
      intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
         // this.startLoading();
         // console.log(`Lanza -> url:${request.url} -> method:${request.method} -> contador: ` + this.loadingCount);

         return new Observable<HttpEvent<any>>(obs => {
            next.handle(request).subscribe(
               (event) => {
                  obs.next(event);
               },
               (err: any) => {
                  if (_.get(err, 'status') === 401) {
                     this.authService.logout();
                  }
                  else if (_.get(err, 'status') === 409) {
                     this.toastService.add({
                        severity: "warn",
                        summary: this.translateService.instant('DUPLICATED.SUMMARY'),
                        detail: this.translateService.instant('DUPLICATED.DETAIL'),
                        life: 5000
                     });
                  }
                  else if (_.includes(_.get(err, 'url'), "exported-") && _.get(err, 'status') === 0) {
                     console.log("API Gateway timeout 504", err);
                  }
                  else {
                     if (!request.url.includes("translations") && _.get(err, 'status') !== 403) {
                        if (request.url.includes("i18n")) {
                           // Default locale if browser locale is not supported by the app
                           this.translateService.currentLang = "en"
                        }
                        else {
                           let currentLanguage = this.translateService.currentLang
      
                           let error = http_errors.errors[currentLanguage][err.status]
                           this.toastService.add({ severity: "error", summary: `ERROR`, detail: `${error}`, life: 5000 });
                        }
                     }
                  }
      
                  // If error status is different than 401 we want to skip refresh token
                  // So we check that and throw the error if it's the case            
                  // this.stopLoading();

                  obs.error(err);
               },
               () => {
                  
                  // this.stopLoading();
                  //console.log('finaliza -> ' + request.url + ' -> contador: ' + this.loadingCount);
                  obs.complete();
               }
            )
      })
   }
 



}
